{
  "ships": [
    {
      "id": "kestrel",
      "name": "Tethys KT-3 Kestrel (leased light utility)",
      "assetId": "ship.kestrel",
      "faction": "player_lease",
      "mass": 20000,
      "inertiaScale": 12,
      "thrustForward": 1440000,
      "thrustReverse": 2700000,
      "thrustLateral": 900000,
      "thrustVertical": 900000,
      "maxSpeed": 300,
      "absMaxSpeed": 450,
      "boostSpeedMult": 1.4,
      "boostThrustMult": 1.8,
      "boostEnergyPerSec": 25,
      "maxRateDeg": { "pitch": 90, "yaw": 70, "roll": 180 },
      "maxAngAccelDeg": { "pitch": 540, "yaw": 420, "roll": 1080 },
      "faGain": 6,
      "rotGain": 12,
      "energy": 100,
      "energyRegen": 20,
      "hull": 300,
      "shield": 200,
      "shieldRegen": 25,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_PDC_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_PDC_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_C", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 },
        { "socket": "HP_TORP_V", "weapon": "torpedo", "module": "hp.torpedo_rack", "group": "secondary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 4.5, 18],
      "chaseRotStiffness": 8
    },
    {
      "id": "interceptor",
      "name": "Varro SI-7 Jackal (raider interceptor)",
      "assetId": "ship.interceptor",
      "faction": "raider",
      "mass": 14000,
      "inertiaScale": 10,
      "thrustForward": 1260000,
      "thrustReverse": 1820000,
      "thrustLateral": 840000,
      "thrustVertical": 840000,
      "maxSpeed": 320,
      "absMaxSpeed": 480,
      "boostSpeedMult": 1.4,
      "boostThrustMult": 1.8,
      "boostEnergyPerSec": 25,
      "maxRateDeg": { "pitch": 120, "yaw": 90, "roll": 240 },
      "maxAngAccelDeg": { "pitch": 720, "yaw": 540, "roll": 1440 },
      "faGain": 7,
      "rotGain": 14,
      "energy": 80,
      "energyRegen": 20,
      "hull": 120,
      "shield": 80,
      "shieldRegen": 15,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 3.5, 14],
      "chaseRotStiffness": 9
    },
    {
      "id": "gunship",
      "name": "Varro GX-4 Bulwark (raider gunship)",
      "assetId": "ship.gunship",
      "faction": "raider",
      "mass": 45000,
      "inertiaScale": 20,
      "thrustForward": 2160000,
      "thrustReverse": 4275000,
      "thrustLateral": 1350000,
      "thrustVertical": 1350000,
      "maxSpeed": 210,
      "absMaxSpeed": 315,
      "boostSpeedMult": 1.3,
      "boostThrustMult": 1.5,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 45, "yaw": 35, "roll": 70 },
      "maxAngAccelDeg": { "pitch": 180, "yaw": 140, "roll": 280 },
      "faGain": 4,
      "rotGain": 8,
      "energy": 120,
      "energyRegen": 15,
      "hull": 500,
      "shield": 300,
      "shieldRegen": 20,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_TURRET_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "turrets": [
        { "socket": "HP_TURRET_L", "weapon": "flakTurret", "facing": [-1, 0, 0] },
        { "socket": "HP_TURRET_R", "weapon": "flakTurret", "facing": [1, 0, 0] }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 7, 30],
      "chaseRotStiffness": 5
    },
    {
      "id": "patrol_interceptor",
      "name": "Varro SI-7 Jackal (security patrol)",
      "assetId": "ship.interceptor",
      "faction": "neutral",
      "mass": 14000,
      "inertiaScale": 10,
      "thrustForward": 1260000,
      "thrustReverse": 1820000,
      "thrustLateral": 840000,
      "thrustVertical": 840000,
      "maxSpeed": 320,
      "absMaxSpeed": 480,
      "boostSpeedMult": 1.4,
      "boostThrustMult": 1.8,
      "boostEnergyPerSec": 25,
      "maxRateDeg": { "pitch": 120, "yaw": 90, "roll": 240 },
      "maxAngAccelDeg": { "pitch": 720, "yaw": 540, "roll": 1440 },
      "faGain": 7,
      "rotGain": 14,
      "energy": 80,
      "energyRegen": 20,
      "hull": 120,
      "shield": 80,
      "shieldRegen": 15,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 3.5, 14],
      "chaseRotStiffness": 9
    },
    {
      "id": "patrol_gunship",
      "name": "Varro GX-4 Bulwark (security patrol)",
      "assetId": "ship.gunship",
      "faction": "neutral",
      "mass": 45000,
      "inertiaScale": 20,
      "thrustForward": 2160000,
      "thrustReverse": 4275000,
      "thrustLateral": 1350000,
      "thrustVertical": 1350000,
      "maxSpeed": 210,
      "absMaxSpeed": 315,
      "boostSpeedMult": 1.3,
      "boostThrustMult": 1.5,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 45, "yaw": 35, "roll": 70 },
      "maxAngAccelDeg": { "pitch": 180, "yaw": 140, "roll": 280 },
      "faGain": 4,
      "rotGain": 8,
      "energy": 120,
      "energyRegen": 15,
      "hull": 500,
      "shield": 300,
      "shieldRegen": 20,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_TURRET_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 7, 30],
      "chaseRotStiffness": 5
    },
    {
      "id": "guardian_interceptor",
      "name": "Unmarked interceptor (rebuilt old hull)",
      "assetId": "ship.interceptor",
      "faction": "first_rush",
      "mass": 14000,
      "inertiaScale": 10,
      "thrustForward": 1260000,
      "thrustReverse": 1820000,
      "thrustLateral": 840000,
      "thrustVertical": 840000,
      "maxSpeed": 320,
      "absMaxSpeed": 480,
      "boostSpeedMult": 1.4,
      "boostThrustMult": 1.8,
      "boostEnergyPerSec": 25,
      "maxRateDeg": { "pitch": 120, "yaw": 90, "roll": 240 },
      "maxAngAccelDeg": { "pitch": 720, "yaw": 540, "roll": 1440 },
      "faGain": 7,
      "rotGain": 14,
      "energy": 80,
      "energyRegen": 20,
      "hull": 132,
      "shield": 80,
      "shieldRegen": 15,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 3.5, 14],
      "chaseRotStiffness": 9
    },
    {
      "id": "hauler",
      "name": "Meridian MF-9 Severn (container hauler)",
      "assetId": "ship.hauler",
      "faction": "meridian",
      "mass": 600000,
      "inertiaScale": 30,
      "thrustForward": 7200000,
      "thrustReverse": 33000000,
      "thrustLateral": 4800000,
      "thrustVertical": 4800000,
      "maxSpeed": 120,
      "absMaxSpeed": 180,
      "boostSpeedMult": 1.2,
      "boostThrustMult": 1.3,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 20, "yaw": 15, "roll": 30 },
      "maxAngAccelDeg": { "pitch": 60, "yaw": 45, "roll": 90 },
      "faGain": 4,
      "rotGain": 5,
      "energy": 100,
      "energyRegen": 10,
      "hull": 800,
      "shield": 200,
      "shieldRegen": 10,
      "shieldRegenDelay": 4,
      "loadout": [{ "socket": "HP_TURRET_T", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }],
      "turrets": [{ "socket": "HP_TURRET_T", "weapon": "pdcTurret", "facing": [0, 1, 0] }],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 12, 60],
      "chaseRotStiffness": 4
    },
    {
      "id": "miner",
      "name": "Tethys HX-2 Cormorant (mining ship)",
      "assetId": "ship.miner",
      "faction": "tethys",
      "mass": 300000,
      "inertiaScale": 25,
      "thrustForward": 4500000,
      "thrustReverse": 19500000,
      "thrustLateral": 3000000,
      "thrustVertical": 3000000,
      "maxSpeed": 140,
      "absMaxSpeed": 210,
      "boostSpeedMult": 1.25,
      "boostThrustMult": 1.3,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 30, "yaw": 25, "roll": 45 },
      "maxAngAccelDeg": { "pitch": 90, "yaw": 75, "roll": 135 },
      "faGain": 4,
      "rotGain": 6,
      "energy": 100,
      "energyRegen": 12,
      "hull": 600,
      "shield": 150,
      "shieldRegen": 10,
      "shieldRegenDelay": 4,
      "loadout": [
        { "socket": "HP_MINING_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_MINING_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 9, 45],
      "chaseRotStiffness": 5
    },
    {
      "id": "cutter",
      "name": "Charter CR-1 Vigilance class (Authority cutter)",
      "assetId": "ship.cutter",
      "faction": "authority",
      "mass": 38000,
      "inertiaScale": 18,
      "thrustForward": 2090000,
      "thrustReverse": 3800000,
      "thrustLateral": 1250000,
      "thrustVertical": 1250000,
      "maxSpeed": 240,
      "absMaxSpeed": 360,
      "boostSpeedMult": 1.3,
      "boostThrustMult": 1.5,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 55, "yaw": 45, "roll": 90 },
      "maxAngAccelDeg": { "pitch": 220, "yaw": 180, "roll": 360 },
      "faGain": 5,
      "rotGain": 9,
      "energy": 120,
      "energyRegen": 16,
      "hull": 420,
      "shield": 320,
      "shieldRegen": 22,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_TURRET_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 8, 34],
      "chaseRotStiffness": 5
    },
    {
      "id": "salvager",
      "name": "Holdfast SV-5 Gleaner (salvage tug)",
      "assetId": "ship.salvager",
      "faction": "holdfast",
      "mass": 220000,
      "inertiaScale": 22,
      "thrustForward": 3520000,
      "thrustReverse": 14300000,
      "thrustLateral": 2420000,
      "thrustVertical": 2420000,
      "maxSpeed": 150,
      "absMaxSpeed": 225,
      "boostSpeedMult": 1.25,
      "boostThrustMult": 1.3,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 35, "yaw": 28, "roll": 50 },
      "maxAngAccelDeg": { "pitch": 105, "yaw": 84, "roll": 150 },
      "faGain": 4,
      "rotGain": 6,
      "energy": 110,
      "energyRegen": 14,
      "hull": 550,
      "shield": 180,
      "shieldRegen": 12,
      "shieldRegenDelay": 4,
      "loadout": [
        { "socket": "HP_CUTTER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_CUTTER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 8, 40],
      "chaseRotStiffness": 5
    },
    {
      "id": "hauler_large",
      "name": "Meridian MF-36 Danube (large hauler)",
      "assetId": "ship.hauler_large_block",
      "faction": "meridian",
      "mass": 1500000,
      "inertiaScale": 40,
      "thrustForward": 15000000,
      "thrustReverse": 75000000,
      "thrustLateral": 9000000,
      "thrustVertical": 9000000,
      "maxSpeed": 100,
      "absMaxSpeed": 150,
      "boostSpeedMult": 1.15,
      "boostThrustMult": 1.2,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 12, "yaw": 9, "roll": 18 },
      "maxAngAccelDeg": { "pitch": 36, "yaw": 27, "roll": 54 },
      "faGain": 3,
      "rotGain": 4,
      "energy": 120,
      "energyRegen": 10,
      "hull": 1600,
      "shield": 400,
      "shieldRegen": 12,
      "shieldRegenDelay": 5,
      "loadout": [
        { "socket": "HP_TURRET_T", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_A", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "turrets": [
        { "socket": "HP_TURRET_T", "weapon": "pdcTurret", "facing": [0, 1, 0] },
        { "socket": "HP_TURRET_A", "weapon": "pdcTurret", "facing": [0, 1, 0] }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 40, 250],
      "chaseRotStiffness": 3
    },
    {
      "id": "corvette",
      "name": "Varro CV-2 Mastiff (command corvette)",
      "assetId": "ship.corvette",
      "faction": "varro_security",
      "mass": 160000,
      "inertiaScale": 26,
      "thrustForward": 4000000,
      "thrustReverse": 12800000,
      "thrustLateral": 2400000,
      "thrustVertical": 2400000,
      "maxSpeed": 180,
      "absMaxSpeed": 270,
      "boostSpeedMult": 1.25,
      "boostThrustMult": 1.4,
      "boostEnergyPerSec": 35,
      "maxRateDeg": { "pitch": 30, "yaw": 24, "roll": 45 },
      "maxAngAccelDeg": { "pitch": 110, "yaw": 90, "roll": 165 },
      "faGain": 4,
      "rotGain": 7,
      "energy": 160,
      "energyRegen": 18,
      "hull": 1200,
      "shield": 600,
      "shieldRegen": 25,
      "shieldRegenDelay": 4,
      "loadout": [
        { "socket": "HP_PDC_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_PDC_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 },
        { "socket": "HP_TURRET_F", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_A", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "turrets": [
        { "socket": "HP_TURRET_F", "weapon": "flakTurret", "facing": [0, 1, 0] },
        { "socket": "HP_TURRET_A", "weapon": "pdcTurret", "facing": [0, 1, 0] }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 10, 50],
      "chaseRotStiffness": 4
    },
    {
      "id": "prisoner_transport",
      "name": "Charter Authority PT-3 Clemency class (prisoner transport)",
      "assetId": "ship.prisoner_transport",
      "faction": "authority",
      "mass": 600000,
      "inertiaScale": 30,
      "thrustForward": 7200000,
      "thrustReverse": 33000000,
      "thrustLateral": 4800000,
      "thrustVertical": 4800000,
      "maxSpeed": 120,
      "absMaxSpeed": 180,
      "boostSpeedMult": 1.2,
      "boostThrustMult": 1.3,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 20, "yaw": 15, "roll": 30 },
      "maxAngAccelDeg": { "pitch": 60, "yaw": 45, "roll": 90 },
      "faGain": 4,
      "rotGain": 5,
      "energy": 100,
      "energyRegen": 10,
      "hull": 800,
      "shield": 200,
      "shieldRegen": 10,
      "shieldRegenDelay": 4,
      "loadout": [{ "socket": "HP_TURRET_T", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }],
      "turrets": [{ "socket": "HP_TURRET_T", "weapon": "pdcTurret", "facing": [0, 1, 0] }],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 10, 50],
      "chaseRotStiffness": 4
    },
    {
      "id": "voss_yacht",
      "name": "Tethys Halcyon (executive yacht)",
      "assetId": "ship.voss_yacht",
      "faction": "tethys",
      "mass": 14000,
      "inertiaScale": 10,
      "thrustForward": 1260000,
      "thrustReverse": 1820000,
      "thrustLateral": 840000,
      "thrustVertical": 840000,
      "maxSpeed": 320,
      "absMaxSpeed": 480,
      "boostSpeedMult": 1.4,
      "boostThrustMult": 1.8,
      "boostEnergyPerSec": 25,
      "maxRateDeg": { "pitch": 120, "yaw": 90, "roll": 240 },
      "maxAngAccelDeg": { "pitch": 720, "yaw": 540, "roll": 1440 },
      "faGain": 7,
      "rotGain": 14,
      "energy": 80,
      "energyRegen": 20,
      "hull": 120,
      "shield": 80,
      "shieldRegen": 15,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 5, 24],
      "chaseRotStiffness": 9
    },
    {
      "id": "meridian_courier",
      "name": "Meridian MC-2 Isar (courier)",
      "assetId": "ship.meridian_courier",
      "faction": "meridian",
      "mass": 14000,
      "inertiaScale": 10,
      "thrustForward": 1260000,
      "thrustReverse": 1820000,
      "thrustLateral": 840000,
      "thrustVertical": 840000,
      "maxSpeed": 320,
      "absMaxSpeed": 480,
      "boostSpeedMult": 1.4,
      "boostThrustMult": 1.8,
      "boostEnergyPerSec": 25,
      "maxRateDeg": { "pitch": 120, "yaw": 90, "roll": 240 },
      "maxAngAccelDeg": { "pitch": 720, "yaw": 540, "roll": 1440 },
      "faGain": 7,
      "rotGain": 14,
      "energy": 80,
      "energyRegen": 20,
      "hull": 120,
      "shield": 80,
      "shieldRegen": 15,
      "shieldRegenDelay": 3,
      "loadout": [
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 4, 20],
      "chaseRotStiffness": 9
    },
    {
      "id": "tethys_kt3p",
      "extends": "kestrel",
      "name": "Tethys KT-3P Prospector (light miner)",
      "assetId": "ship.tethys_kt3p_block",
      "faction": "tethys",
      "thrustReverse": 3105000,
      "maxSpeed": 270,
      "absMaxSpeed": 405,
      "energyRegen": 19,
      "hull": 345,
      "loadout": [
        { "socket": "HP_PDC_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_PDC_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_C", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 },
        { "socket": "HP_MINING_C", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 }
      ]
    },
    {
      "id": "tethys_gannet",
      "extends": "hauler_large",
      "flightBand": "L",
      "name": "Tethys HX-4 Gannet (mining tender)",
      "assetId": "ship.tethys_gannet_block",
      "faction": "tethys",
      "thrustReverse": 86250000,
      "maxSpeed": 90,
      "absMaxSpeed": 135,
      "energyRegen": 9.5,
      "hull": 1840,
      "chaseOffset": [0, 30, 170],
      "mining": { "booms": ["HP_BOOM_0", "HP_BOOM_1", "HP_BOOM_2", "HP_BOOM_3"] }
    },
    {
      "id": "tethys_skua",
      "extends": "hauler_large",
      "flightBand": "L",
      "name": "Tethys WB-8 Skua (wreck-breaker)",
      "assetId": "ship.tethys_skua_block",
      "faction": "tethys",
      "thrustReverse": 86250000,
      "maxSpeed": 90,
      "absMaxSpeed": 135,
      "energyRegen": 9.5,
      "hull": 1840,
      "chaseOffset": [0, 28, 160]
    },
    {
      "id": "varro_warhound",
      "extends": "hauler_large",
      "flightBand": "L",
      "name": "Varro FX-1 Warhound (frigate)",
      "assetId": "ship.varro_warhound_block",
      "faction": "varro_security",
      "thrustForward": 16500000,
      "thrustReverse": 82500000,
      "maxSpeed": 110,
      "absMaxSpeed": 165,
      "energyRegen": 9,
      "hull": 1440,
      "loadout": [
        { "socket": "HP_TURRET_FL", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_FR", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_AL", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_AR", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "turrets": [
        { "socket": "HP_TURRET_FL", "weapon": "flakTurret", "facing": [0, 1, 0] },
        { "socket": "HP_TURRET_FR", "weapon": "flakTurret", "facing": [0, 1, 0] },
        { "socket": "HP_TURRET_AL", "weapon": "pdcTurret", "facing": [0, 1, 0] },
        { "socket": "HP_TURRET_AR", "weapon": "pdcTurret", "facing": [0, 1, 0] }
      ],
      "chaseOffset": [0, 32, 190]
    },
    {
      "id": "varro_mastiff_b",
      "extends": "corvette",
      "name": "Varro CV-2B Mastiff (bomber corvette)",
      "assetId": "ship.varro_mastiff_b_block",
      "thrustForward": 4400000,
      "thrustReverse": 14080000,
      "maxSpeed": 198,
      "absMaxSpeed": 297,
      "energyRegen": 16.2,
      "hull": 1080,
      "loadout": [
        { "socket": "HP_PDC_L", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_PDC_R", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 1 },
        { "socket": "HP_TORP_L", "weapon": "torpedo", "module": "hp.torpedo_rack", "group": "secondary", "slot": 0 },
        { "socket": "HP_TORP_R", "weapon": "torpedo", "module": "hp.torpedo_rack", "group": "secondary", "slot": 0 }
      ],
      "turrets": []
    },
    {
      "id": "holdfast_picket",
      "extends": "interceptor",
      "name": "Holdfast EC-3 Picket (escort interceptor)",
      "assetId": "ship.holdfast_picket_block",
      "faction": "holdfast",
      "maxSpeed": 288,
      "absMaxSpeed": 432,
      "energyRegen": 23,
      "chaseOffset": [0, 4.5, 20]
    },
    {
      "id": "holdfast_wayfinder",
      "extends": "kestrel",
      "name": "Holdfast PF-1 Wayfinder (pathfinder survey ship)",
      "assetId": "ship.holdfast_wayfinder_block",
      "faction": "holdfast",
      "maxSpeed": 270,
      "absMaxSpeed": 405,
      "energyRegen": 23,
      "loadout": [
        { "socket": "HP_LASER_L", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 },
        { "socket": "HP_LASER_R", "weapon": "pulseLaser", "module": "hp.pulse_laser", "group": "primary", "slot": 0 }
      ],
      "chaseOffset": [0, 5, 26]
    },
    {
      "id": "holdfast_delver",
      "extends": "miner",
      "name": "Holdfast DS-2 Delver (deep-seam prospector)",
      "assetId": "ship.holdfast_delver_block",
      "faction": "holdfast",
      "maxSpeed": 126,
      "absMaxSpeed": 189,
      "energyRegen": 13.8,
      "chaseOffset": [0, 10, 55]
    },
    {
      "id": "relic_escort",
      "extends": "holdfast_picket",
      "name": "Charter-pattern escort (maker's mark worn off)",
      "assetId": "ship.relic_escort_block",
      "faction": "first_rush"
    },
    {
      "id": "relic_skiff",
      "extends": "holdfast_wayfinder",
      "name": "Charter-pattern skiff (maker's mark worn off)",
      "assetId": "ship.relic_skiff_block",
      "faction": "first_rush"
    },
    {
      "id": "relic_salvage_tug",
      "extends": "salvager",
      "name": "Charter-pattern salvage tug (maker's mark worn off)",
      "assetId": "ship.relic_salvage_tug_block",
      "faction": "first_rush"
    },
    {
      "id": "testbed_large",
      "name": "Testbed (L)",
      "assetId": "ship.testbed_large",
      "faction": "meridian",
      "flightBand": "L",
      "mass": 6000000,
      "inertiaScale": 120,
      "thrustForward": 30000000,
      "thrustReverse": 150000000,
      "thrustLateral": 18000000,
      "thrustVertical": 18000000,
      "maxSpeed": 90,
      "absMaxSpeed": 135,
      "boostSpeedMult": 1,
      "boostThrustMult": 1,
      "boostEnergyPerSec": 30,
      "maxRateDeg": { "pitch": 10, "yaw": 8, "roll": 15 },
      "maxAngAccelDeg": { "pitch": 25, "yaw": 20, "roll": 35 },
      "faGain": 2,
      "rotGain": 3,
      "energy": 200,
      "energyRegen": 15,
      "hull": 4000,
      "shield": 1000,
      "shieldRegen": 20,
      "shieldRegenDelay": 6,
      "loadout": [
        { "socket": "HP_TURRET_F", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 },
        { "socket": "HP_TURRET_A", "weapon": "pdc", "module": "hp.pdc", "group": "primary", "slot": 0 }
      ],
      "turrets": [
        { "socket": "HP_TURRET_F", "weapon": "pdcTurret", "facing": [0, 1, 0] },
        { "socket": "HP_TURRET_A", "weapon": "pdcTurret", "facing": [0, 1, 0] }
      ],
      "eyeOffset": [0, 0, 0],
      "chaseOffset": [0, 40, 220],
      "chaseRotStiffness": 2
    }
  ]
}
